import { render, staticRenderFns } from "./delete-column-modal.vue?vue&type=template&id=75068a54&"
import script from "./delete-column-modal.vue?vue&type=script&lang=js&"
export * from "./delete-column-modal.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports